'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer,
    $resultList,
    $searchForm,
    $searchField;

/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {

    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultList.filter('.selected').removeClass('selected');

    var $newSelected = $resultList.eq(listCurrent);

    $newSelected.addClass('selected');
    $('input[name="q"]').val($newSelected.find('.product-name').first().text());
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $simpleSearch = $('.js-simple-search');
        var $mobileSearchContainer = $('.js-mobile-search');
        var $defaultSearchContainer = $('#navigation .header-search');
        var helpers = {
            replaceSearch ($parent) {
                $simpleSearch.appendTo($parent);
                $resultsContainer.appendTo($parent);
            },
            hasSimpleSearch($parent) {
                return $parent.children('.js-simple-search').length;
            }
        };

        const {replaceSearch, hasSimpleSearch} = helpers;

        if (util.isMobiles()) {
            $simpleSearch.appendTo($searchContainer);
        }
        
        $searchForm = $searchContainer.find($simpleSearch);
        $searchField = $searchForm.find('input[name="q"]');

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);

                $resultsContainer.off('.removeSelected').on('mouseenter.removeSelected', '.product-suggestion', function(){
                    $resultsContainer.find('.selected').removeClass('selected');
                    listCurrent = -1;
                });
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
            if($searchField.val() == ''){
                $searchField.keyup();
            }
        });

        util.isMobile() && $(window).on('resize', () => {
            if (util.isMobiles() && !hasSimpleSearch($mobileSearchContainer)) {
                replaceSearch($mobileSearchContainer);
            }

            if (util.isTablet() && !hasSimpleSearch($defaultSearchContainer)) {
                replaceSearch($defaultSearchContainer);
            }
        });

        // on key up listener
        $searchField.on('keyup', function (e) {

            if(e.keyCode || window.event.keyCode){
            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                return;
            }
        }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }
        var isSearchPhrasesEnabled = SitePreferences.IS_SEARCH_PHRASES_ENABLED;
        
        // if it's empty and isSearchPhrasesEnabled is not enabled clear the results box and return
        if (runningQuery.length === 0 && !isSearchPhrasesEnabled) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery && runningQuery.length != 0) {
            runningQuery = null;
            return;
        }

        // build the request url
        const isAzHeader = $('.az-header').length;
        var reqUrl = util.appendParamToURL(isAzHeader ? Urls.sgSearchsuggest : Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
                $resultList = $resultsContainer.find('.product-suggestion');
                listTotal = $resultList.length;

            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(0, function () {$resultsContainer.empty();});

        
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    }
};

module.exports = searchsuggest;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/searchsuggest.js